import LockIcon from "@mui/icons-material/Lock";
import {
  ClickAwayListener,
  Grow,
  ListItemIcon,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";

export const FuncionariosOptionsMenu = ({ onClose, onPermissions, ...props }) => {
  const handlePermissions = () => {
    onPermissions();
    onClose();
  };

  return (
    <Popper role={undefined} placement="bottom-start" transition {...props}>
      {({ TransitionProps, placement }) => {
        return (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom-start" ? "left top" : "left bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={onClose}>
                <MenuList
                  autoFocusItem={props.open}
                  id="funcionario-options-menu"
                  aria-labelledby="funcionario-options-button"
                >
                  <MenuItem onClick={handlePermissions}>
                    <ListItemIcon>
                      <LockIcon />
                    </ListItemIcon>
                    Permissões
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        );
      }}
    </Popper>
  );
};
